export default "~이다\n또는\n어디\n무엇\n어떻게\n얼마나\n얼마나 많이\n~해야 한다\n~할 수 있다"